// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-copyright {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: rgb(35, 36, 42);
  color: rgba(255, 255, 255, 0.48);
  text-align: center;
  font-size: 10px;
  padding: 10px; /* Adjust padding as needed for spacing */
}`, "",{"version":3,"sources":["webpack://./src/component/layout/Footer.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,SAAA;EACA,WAAA;EACA,iCAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA,EAAA,yCAAA;AACJ","sourcesContent":[".footer-copyright {\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    background-color: rgba(35, 36, 42, 1);\n    color: rgba(255, 255, 255, 0.48);\n    text-align: center;\n    font-size: 10px;\n    padding: 10px; /* Adjust padding as needed for spacing */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
